"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areaGetRequest = areaGetRequest;
exports.areaAddPostRequest = areaAddPostRequest;
exports.areaUpdatePatchRequest = areaUpdatePatchRequest;
exports.areaDeleteRequest = areaDeleteRequest;
exports.areaMovePostRequest = areaMovePostRequest;
exports.moveBranchesPostRequest = moveBranchesPostRequest;
async function areaGetRequest(userId, activeBranchId, options) {
    const params = new URLSearchParams();
    if (options?.parentId) {
        params.append("parentID", options.parentId.toString());
    }
    // Retrieves subareas up to the specified depth (parent is depth 1; max allowed depth is 10)
    if (options?.maxDepth !== undefined) {
        params.append("maxDepth", options.maxDepth.toString());
    }
    params.append("c", activeBranchId.toString());
    try {
        const response = await fetch(`/dashboard/${userId}/area?${params}`, {
            method: 'GET',
        });
        return await response.json();
    }
    catch (err) {
        throw err;
    }
}
async function areaAddPostRequest(userId, activeBranchId, payload) {
    const data = new URLSearchParams({
        "name": payload.name,
    });
    if (payload?.parentId) {
        data.append("parentID", payload.parentId.toString());
    }
    try {
        const response = await fetch(`/dashboard/${userId}/area?c=${activeBranchId}`, {
            method: 'POST',
            headers: { "Content-Type": "application/x-www-form-urlencoded", },
            body: data.toString(),
        });
        return await response.json();
    }
    catch (err) {
        throw err;
    }
}
async function areaUpdatePatchRequest(userId, activeBranchId, payload) {
    const data = new URLSearchParams({});
    if (payload?.name) {
        data.append("name", payload.name);
    }
    try {
        const response = await fetch(`/dashboard/${userId}/area/${payload.areaId}?c=${activeBranchId}`, {
            method: 'PATCH',
            headers: { "Content-Type": "application/x-www-form-urlencoded", },
            body: data.toString(),
        });
        if (!response.ok) {
            throw new Error();
        }
        return;
    }
    catch (err) {
        throw err;
    }
}
async function areaDeleteRequest(userId, activeBranchId, params) {
    const url = `/dashboard/${userId}/area/${params.id}?keepChildAreas=${params.keepChildAreas}&c=${activeBranchId}`;
    try {
        const response = await fetch(url, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            throw new Error();
        }
    }
    catch (err) {
        throw err;
    }
}
async function areaMovePostRequest(userId, activeBranchId, payload) {
    const data = new URLSearchParams({
        areaID: payload.areaId.toString(),
    });
    if (payload?.parentId) {
        data.append("parentAreaID", payload.parentId.toString());
    }
    if (payload.positionToInsert !== undefined) {
        data.append("positionToInsert", String(payload.positionToInsert));
    }
    try {
        const response = await fetch(`/dashboard/${userId}/area/move?c=${activeBranchId}`, {
            method: 'POST',
            headers: { "Content-Type": "application/x-www-form-urlencoded", },
            body: data.toString(),
        });
        if (!response.ok) {
            throw new Error();
        }
        return;
    }
    catch (err) {
        throw err;
    }
}
// Move branches between areas/subareas or update position
async function moveBranchesPostRequest(userId, activeBranchId, payload) {
    const data = {
        targetAreaID: payload.targetAreaId,
        branchIDs: payload.branchIds,
        positionToInsert: payload.positionToInsert,
    };
    try {
        const response = await fetch(`/dashboard/${userId}/area/move-branches?c=${activeBranchId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
        });
        if (!response.ok) {
            throw new Error();
        }
        return;
    }
    catch (err) {
        throw err;
    }
}
